import React from "react";
import Header from "../components/Pages/Header";
import { Box } from "@chakra-ui/react";
import VideoTimerSection from "../components/Pages/VideoTimerSection";
import MarqueBanner from "../components/Pages/MarqueBanner";
import AboutSection from "../components/Pages/AboutSection";
import TabScheduleSection from "../components/Pages/TabScheduleSection";
import TestimonialsSection from "../components/Pages/TestimonialsSection";
import EventsSection from "../components/Pages/EventSection";
import Footer from "../components/Pages/Footer";
import HeroSection from "../components/Pages/HeroSection";
import VideoSection from "../components/Pages/VideoSection";
const Home = () => {
  return (
    <Box bg="brand.50">
      <Header />
      <HeroSection />
      <VideoTimerSection />
      <MarqueBanner />
      <AboutSection />
      <VideoSection/>
      <TabScheduleSection />
      <TestimonialsSection />
      <MarqueBanner />
      <EventsSection />
      <Footer />
    </Box>
  );
};

export default Home;
